export const ENTITY_TAB_BUILDINGS_DEFAULT_QA_NAME = {
  addNew: 'entityTabBuildingsAddNew',
  editBuildings: 'entityTabBuildingsEdit',
  table: 'entityTabBuildings',
}

export const ENTITY_TAB_BUILDINGS_SCALAR_SCOPE_FILTER_KEYS = ['staff_member']
